module.exports = __webpack_public_path__ + "img/icon_fleet.16244178.png";